import Vue from 'vue'
var CryptoJS = require("crypto-js")

export default {
  CLEAR_FRIDGE: (state) => {
    Vue.set(state, 'surveyFridge', {})
    Vue.set(state, 'dataSet', {})
  },
  SET_SURVEY_FRIDGE_DATA: (state, { survey, surveyId }) => {
    Vue.set(state.surveyFridge, surveyId, survey)
  },
  SAVE_PREVIOUS_SURVEY: (state, { previousSurveyId, previousResponseSetId }) => {
    Vue.set(state.completed, previousSurveyId, new Date().getTime())
    state.survey.previousSurveyId = previousSurveyId
    state.survey.previousResponseSetId = previousResponseSetId
  },
  STORE_FACEBOOK_DATA: (state, { response }) => {
    state.fbData = response
  },
  STORE_FACEBOOK_RESPONSE: (state, { response }) => {
    state.fbAuthResponse = response
  },
  SET_DFP: (state) => {
    if (!state.dfp) {
      state.dfp = btoa(Math.random()).substring(0,24)
    }
  },
  STORE_LOCATION_ITEM: (state, { field, value }) => {
    state.survey.location[field] = value
  },
  STORE_GEOLOCATION: (state, value) => {
    Vue.set(state.survey, 'geolocation', value)
  },
  STORE_GEOLOCATION_ACCURACY: (state, value) => {
    Vue.set(state.survey.geo, 'accuracy', value)
  },  
  STORE_SELF_GEOLOCATION: (state, value) => {
    Vue.set(state.survey, 'selfGeolocation', value)
  },
  STORE_GEOLOCATION_DISTANCE: (state, value) => {
    Vue.set(state.survey.geo, 'distance', value)
  },  
  SET_SURVEY_TOKEN: (state, { token }) => {
    state.survey.token = token
  },  
  SAVE_GOOGLE_RECAPTCHA_TOKEN: (state, { captchaToken }) => {
    state.survey.captchaToken = captchaToken
  },  
  SET_SURVEY_DATA: (state, { survey, surveyId }) => {
    Vue.set(state, 'dataSet', survey.dataSet)
    state.survey.surveyName = survey.surveyName
    state.survey.surveyId = surveyId
    state.survey.allowOnlyOneResponse = survey.allowOnlyOneResponse
    state.survey.customCTA.show = survey.showCustomCta
    state.survey.customCTA.label = survey.customCtaLabel
    state.survey.customCTA.link = survey.customCtaLink
    state.survey.disallowBackButton = survey.disallowBackButton
    state.survey.showTestResults = survey.showTestResults
    state.survey.testResults = survey.testResults
    state.survey.threshold = survey.threshold
    state.survey.surveyIfBelowThreshold = survey.surveyIfBelowThreshold
    state.survey.surveyIfAboveThreshold = survey.surveyIfAboveThreshold
    state.survey.customThankYouPage = survey.thankYouPage
    state.survey.collectPersonalData = survey.collectPersonalData
    state.survey.questionCount = survey.dataSet ? survey.dataSet.length : 0
    state.survey.surveyAlias = survey.surveyAlias
    state.survey.backgroundImage = survey.backgroundImage
    state.survey.language = survey.language
    state.survey.shortcodeTakeThisTest = survey.shortcodeTakeThisTest
    state.survey.hubSpotUser = survey.hubSpotUser
    state.survey.hubSpotForm = survey.hubSpotForm
    state.survey.ogTitle = survey.ogTitle
    state.survey.ogDescription = survey.ogDescription
    state.survey.ogImage = survey.ogImage
    if (state.responses.length !== state.survey.current) {
      state.responses = []
      state.survey.current = 0
      state.survey.status = 'started'
    }
  },

  ADMIN_SET_SURVEY: (state, { survey, surveyId }) => {
    Vue.set(state.admin.sidList, surveyId, survey)
    Vue.set(state, 'dataSet', survey.dataSet)
    state.survey.surveyName = survey.surveyName
    state.survey.surveyAlias = survey.surveyAlias
    state.survey.surveyId = surveyId
    state.survey.testResults = survey.testResults
  },

  SET_FINGERPRINT: (state, { fingerprint }) => {
    state.fingerprint = fingerprint
  },

  SAVE_RECENT_SURVEY_SET: (state, { recentSurveySetId }) => {
    state.survey.recentSurveySetId = recentSurveySetId
  },

  DELETE_RECENT_SURVEY_SET: (state, { recentSurveySetId }) => {
    state.survey.recentSurveySetId = ''
  },

  SET_COLLECT: (state, { collect }) => {
    state.survey.collectPersonalData = collect
  },

  ADMIN_SET_SID: (state, { surveyId }) => {
    if (!surveyId) {
      Vue.set(state, 'dataSet', {})
    }
    state.admin.sid = surveyId
  },

  SET_SURVEY_REFS: (state, { data }) => {
    state.surveyRefs = data
  },

  SET_DISPLAY: (state, { data }) => {
    Vue.set(state, 'display', data)
  },

  SET_SITE_LANG: (state, { lang }) => {
    Vue.set(state.site, 'language', lang)
  },

  SET_SITE_DATA: (state, { site, siteId }) => {
    Vue.set(state.site, 'pages', site.pages)

    state.site.content = {}

    // Iterate up to a third level to find the corresponding inner pages
    if (site.webLevelEn) {
      state.site.content[`${site.webLevelEn.fields.alias}`] = site.webLevelEn
      if (site.webLevelEn.fields.webLevel && site.webLevelEn.fields.webLevel.length) {
        site.webLevelEn.fields.webLevel.forEach(level1 => {
          state.site.content[`/${level1.fields.alias}`] = level1
          if (level1.fields.webLevel && level1.fields.webLevel.length) {
            level1.fields.webLevel.forEach(level2 => {
              state.site.content[`/${level1.fields.alias}/${level2.fields.alias}`] = level2
            })
          }
        })
      }
    }

    if (site.webLevelEs) {
      state.site.content[`/es`] = site.webLevelEs
      if (site.webLevelEs.fields.webLevel && site.webLevelEs.fields.webLevel.length) {
        site.webLevelEs.fields.webLevel.forEach(level1 => {
          state.site.content[`/es/${level1.fields.alias}`] = level1
          if (level1.fields.webLevel && level1.fields.webLevel.length) {
            level1.fields.webLevel.forEach(level2 => {
              state.site.content[`/es/${level1.fields.alias}/${level2.fields.alias}`] = level2
            })
          }
        })
      }
    }

    state.site.isLoaded = true
  },

  SET_TEST_RESULTS_DATA: (state, { data }) => {
    state.testResults = data
  },
  STORE_USER_PROFILE: (state, { profile, profileId }) => {
    state.user.profileId = profileId
    state.user.profile = profile
  },
  CLEAR_USER_PROFILE: (state) => {
    state.user = {}
  },
  BROWSER_REPORT: (state, { report }) => {
    state.survey.browserReport = report
  },
  STORE_RESPONSE: (state, { qid, response }) => {
    state.responses[qid] = response
  },
  STORE_RESPONSE_NEW: (state, { qid, response }) => {
    state.responses[qid] = response
    if (response && response.selected || response.terms) {
      state.newResponses[`q${qid}`] = {}
      state.newResponses[`q${qid}`]['identifier'] = response.identifier
      state.newResponses[`q${qid}`]['contentfulId'] = response.id
      state.newResponses[`q${qid}`]['qid'] = qid
      state.newResponses[`q${qid}`]['type'] = response.type
      state.newResponses[`q${qid}`]['numberOfOptions'] = response.numberOfOptions
      state.newResponses[`q${qid}`]['questionLength'] = response.question ? response.question.length : ''
      state.newResponses[`q${qid}`]['question'] = response.question
      state.newResponses[`q${qid}`]['selected'] = response.selected.join('/')
      state.newResponses[`q${qid}`]['terms'] = response.terms
      state.newResponses[`q${qid}`]['timeToCompletion'] = response.timeToCompletion

      // if it's likert, do something special
      if (response.from && response.to) {
        var diff = response.to - response.from
        state.newResponses[`q${qid}`]['n_selected'] = parseInt(response.selected, 10)
        state.newResponses[`q${qid}`]['n_0-100'] = ( response.selected - 1 ) * 100 / diff
        state.newResponses[`q${qid}`]['n_centered'] = ( response.selected - 1 ) * 100 / diff - 50
      }

      if (response.splitSelected) {
        state.newResponses[`q${qid}`]['splitSelected'] = response.splitSelected
      }
      if (response.labelSelection) {
        state.newResponses[`q${qid}`]['labelSelection'] = response.labelSelection
      }
      if (!isNaN(parseInt(response.selected[0], 10))) {
        state.newResponses[`q${qid}`]['n_selected'] = parseInt(response.selected[0], 10)
      }
    }
  },
  SET_CURRENT: (state, { current }) => {
    state.survey.current = current
  },
  SET_ACTUAL_QID: (state, { qid }) => {
    state.survey.qid = qid
  },
  SET_SURVEY_STATUS: (state, { status }) => {
    state.survey.status = status
    if (status !== 'started') {
      state.survey.current = 0
    }
  },
  CLEAR_RESPONSES: (state) => {
    state.responses = []
    state.newResponses = {}
    state.survey.status = 'sent'
  },
  CLEAR_FORM: (state) => {
    state.responses = []
    state.newResponses = {}
    state.survey.current = null
    state.survey.status = 'started'
    state.survey.surveyId = null
    state.survey.current = 0
    state.survey.qid = 0
    state.survey.token = 'koku'
    state.survey.captchaToken = ''
  },
  RESTART_FORM: (state) => {
    state.responses = []
    state.newResponses = {}
    state.survey.current = 0
    state.survey.status = 'started'
  },
  STORE_TEST_RESULT: (state, { weightedTestResults }) => {
    state.survey.weightedTestResults = weightedTestResults
  },
  STORE_PROFILE_IN_SURVEY: (state, { profile }) => {
    state.survey.profile = profile.fields.name
  },
  STORE_REQUEST_PARAMS: (state, { params }) => {
    state.survey.params = params
  },
  /*
   * Auth0 stuff
   */
  AUTH0_SET_USER: (state, user) => {
    if (user.user && user.user.sub) {
      Vue.set(state.user, 'auth0', user.user)
      Vue.set(state.user, 'loggedIn', true)
    } else {
      Vue.set(state.user, 'auth0', {})
      Vue.set(state.user, 'loggedIn', false)
    }
  },
  // This shouldn't be stored in localStorage
  SAVE_TOKEN: (state, { accessToken, idToken }) => {
    Vue.set(state.user.token, 'accessToken', accessToken)
    Vue.set(state.user.token, 'idToken', idToken)
  },
  LOG_OFF: (state) => {
    Vue.set(state.user, 'auth0', {})
    Vue.set(state.user, 'tokenData', {})
    state.user.loggedIn = false
  },
  /* ADMIN PLAY STUFF */
  SET_ADMIN_STATE: (state, { status }) => {
    state.admin.play.status = status
    state.admin.play.startTimestamp = new Date().getTime()
  },
  SET_ANALYZE_START_TIMESTAMP: (state, { timestamp }) => {
    state.admin.play.startTimestamp = timestamp
  },
  SET_ANALYZE_END_TIMESTAMP: (state, { timestamp }) => {
    state.admin.play.endTimestamp = timestamp
  }

}
